import { useQuery } from '@tanstack/react-query';
import { fetchExamOverview } from '../services/examCategoryService';

export function useExamOverview(examsId) {
  return useQuery({
    queryKey: ['examOverview', Number(examsId)],
    queryFn: () => fetchExamOverview(Number(examsId)),
    enabled: Number(examsId) > 0,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
}
